import { Mail } from "lucide-react";
import { BUSINESS } from "@/lib/content";
import { Eyebrow, MaskLines, Reveal } from "@/components/site/Motion";
import QuoteForm from "@/components/site/QuoteForm";

const STEPS = [
  ["Votre demande", "Décrivez votre besoin en 2 minutes via le formulaire."],
  ["Notre étude", "Nous analysons votre demande et vous recontactons rapidement."],
  ["Votre devis", "Vous recevez une proposition claire, adaptée à vos locaux."],
];

export default function QuoteSection() {
  return (
    <section id="devis" className="relative py-24 sm:py-36 bg-[#0c1222]/40 border-t border-white/5" data-testid="quote-section">
      <div className="pointer-events-none absolute right-0 top-20 h-[500px] w-[500px] rounded-full bg-[#22a6ff]/10 blur-[160px]" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-32">
            <Eyebrow index="04">Devis gratuit</Eyebrow>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl font-semibold tracking-tight text-white leading-[1.02]">
              <MaskLines inView lines={["Parlons de", <span key="d" className="font-serif-i text-brand">vos locaux.</span>]} />
            </h2>
            <Reveal delay={0.15}>
              <ol className="mt-10 space-y-6">
                {STEPS.map(([t, d], i) => (
                  <li key={t} className="flex gap-5">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-cyan-300/40 font-mono-uc text-xs text-cyan-300">
                      0{i + 1}
                    </span>
                    <div>
                      <div className="font-display text-lg text-white">{t}</div>
                      <div className="text-sm text-slate-400 leading-relaxed">{d}</div>
                    </div>
                  </li>
                ))}
              </ol>
              <a
                href={`mailto:${BUSINESS.email}`}
                className="mt-10 inline-flex items-center gap-3 text-sm text-slate-300 hover:text-cyan-300 transition-colors duration-300"
                data-testid="quote-contact-email-link"
              >
                <Mail className="h-4 w-4" /> {BUSINESS.email}
              </a>
            </Reveal>
          </div>
        </div>
        <div className="lg:col-span-8">
          <Reveal>
            <QuoteForm />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
